/** @format */

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { AiOutlineGoogle } from "react-icons/ai";
import { FaFacebook } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Footer from "../components/Footer";
import Headers from "../components/Headers";
import { customer_register } from "../store/reducers/authReducer";
import { messageClear } from "../store/reducers/homeReducer";
import { useCategories } from "../utils/Categories";

const Register = () => {
  const navigate = useNavigate();
  const { loader, successMessage, messageError } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
  });
  const inputHandle = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  const registerHandle = (e) => {
    e.preventDefault();
    dispatch(customer_register(state));
  };

  const { categories, clientLocation } = useCategories();
  //console.log("categories ", categories)
  //if (loading) return <div>Loading...</div>;
  // if (errorMessage) return <div>Error: {errorMessage}</div>;
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      //navigate('/login');
      navigate("/verify/account");
    }
    if (messageError) {
      toast.error(messageError);
      dispatch(messageClear());
    }
  }, [successMessage, messageError, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
          <FadeLoader />
        </div>
      )}
      <Headers categories={categories} clientLocation={clientLocation} />
      <div className='bg-slate-200 mt-4'>
        <div className='w-full justify-center items-center p-10'>
          <div className='grid grid-cols-2 md-lg:flex md-lg:flex-col md-lg:w-[80%] md:w-[90%]  sm:w-[95%] w-[60%] mx-auto bg-white rounded-md'>
            <div className='px-8 py-8'>
              <h2 className='text-center ww-full text-xl text-slate-600 font-bold'>
                {t("Registration")}
              </h2>
              <div className='flex flex-col'>
                <form onSubmit={registerHandle} className='text-slate-600'>
                  <div className='flex flex-col gap-1 mb-2'>
                    <label htmlFor='name'>{t("Name")}</label>
                    <input
                      required
                      onChange={inputHandle}
                      value={state.name}
                      type='text'
                      name='name'
                      id='name'
                      placeholder={t("Your name")}
                      className='w-full px-3 py-2 border border-slate-200 
                                    outline-none focus:border-indigo-500 rounded-md '
                    />
                  </div>
                  <div className='flex flex-col gap-1 mb-2'>
                    <label htmlFor='email'>Email</label>
                    <input
                      required
                      onChange={inputHandle}
                      value={state.email}
                      type='email'
                      name='email'
                      id='email'
                      placeholder={t("Your email")}
                      className='w-full px-3 py-2 border border-slate-200 
                                    outline-none focus:border-indigo-500rounded-md '
                    />
                  </div>
                  <div className='flex flex-col gap-1 mb-2'>
                    <label htmlFor='password'>{t("Password")}</label>
                    <input
                      required
                      onChange={inputHandle}
                      value={state.password}
                      type='password'
                      name='password'
                      id='password'
                      placeholder={t("your password")}
                      className='w-full px-3 py-2 border 
                                    border-slate-200 outline-none focus:border-indigo-500rounded-md '
                    />
                  </div>
                  <button
                    onClick={registerHandle}
                    className='px-8 py-2 w-full bg-blue-700 rounded-md text-md font-semibold text-white cursor-pointer'
                  >
                    {t("Register")}
                  </button>
                </form>
                <div className='flex justify-center items-center py-2'>
                  <div className='h-1 bg-slate-300 w-[95%]'></div>
                  <span className='px-3 text-slate-600'>{t("or")}</span>
                  <div className='h-1 bg-slate-300 w-[95%]'></div>
                </div>
                <button
                  className='px-8 w-full py-2 bg-indigo-500 shadow hover:shadow-indigo-500/30 text-white rounded-md flex
                          justify-start items-center gap-2 mb-3'
                >
                  <span>
                    <FaFacebook />
                  </span>
                  <span>{t("Login with Facebook")}</span>
                </button>
                <button
                  className='px-8 w-full py-2 bg-orange-500 shadow hover:shadow-orange-500/30 text-white rounded-md flex
                          justify-start items-center gap-2 mb-3'
                >
                  <span>
                    <AiOutlineGoogle />
                  </span>
                  <span>{t("Login with Google")}</span>
                </button>
              </div>
              <div>
                <p className='text-center text-slate-600 text-sm'>
                  {t("Already have an account")}?{" "}
                  <Link to='/login' className='text-blue-600 font-bold'>
                    {t("Login")}
                  </Link>
                </p>
              </div>
              <div>
                <p className='text-center text-slate-600 text-sm'>
                  <a
                    target='_black'
                    href={`${process.env.REACT_APP_DASHBOARD_URL}/login`}
                    className='text-blue-600 font-bold'
                  >
                    {t("Login")}
                  </a>{" "}
                  {t("Seller Account")}
                </p>
              </div>
            </div>
            <div className='w-full h-full py-4 pr-4 justify-center items-center'>
              <img
                className='w-full items-center justify-center'
                src='/images/shopping.png'
                alt='shopping'
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
